import React, { useState } from "react";
import DataTable from "../../../../components/AdminTable/DataTable";

function CustomerDueReport() {
  const [columns] = useState([
    {
      header: "SN",
      accessorKey: "SN",
    },
    {
      header: "Supplier",
      accessorKey: "Supplier    ",
    },
    {
      header: "Payable Due",
      accessorKey: "Payable Due",
    },
  ]);
  const [data] = useState([]);

  return (
    <main className="my-16">
      <div className="text-d-bg-text text-3xl text-center my-4">
        Customer Due Report
      </div>
      <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>

      <DataTable columns={columns} data={data} />
    </main>
  );
}

export default CustomerDueReport;
